import { OrganizationDto } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { tracking } from '@sib/tracking';
import { Button } from '@sib/ui';
import { SPENDBRAIN_LEARN_MORE_URL } from '@spendbrain/config/constants';

interface ActivateAiModalFooterProps {
  organization: OrganizationDto | undefined;
}

export const ActivateAiModalFooter = ({
  organization,
}: ActivateAiModalFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4">
      {organization?.manager?.email && (
        <Button
          variant="outline"
          size="sm"
          color="primary"
          asChild
          onClick={() => tracking.track('Contact Team AI Member clicked')}
        >
          <a
            href={`mailto:${organization.manager.email}?subject=${encodeURIComponent(
              t('aiServiceModal.spendbrainActivationSubject')
            )}`}
          >
            {t('aiServiceModal.askSpendBrainContact')}
          </a>
        </Button>
      )}
      <Button
        size="sm"
        color="primary"
        asChild
        onClick={() => tracking.track('Learn more about AI clicked')}
      >
        <a
          href={SPENDBRAIN_LEARN_MORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('aiServiceModal.learnMore')}
        </a>
      </Button>
    </div>
  );
};
